import React from "react";
import { Dropdown } from "semantic-ui-react";

import useApiService from "../../../services/useApiService";
import LanguageService from "../../../services/languageService";
import "./index.css";

export default function WorkphaseCellFormatter(props) {
  const { cell, row, translations, canUpdate } = props;
  const [_, updateBuisnessAreas] = useApiService({
    url: `/risks/${row.id}/tags`,
    method: "put",
  });

  const handleDropdownChange = (_, { value }) => {
    updateBuisnessAreas({
      business_area_list: value.join(","),
      plan_id: row.plan_id,
    });
  };

  const options = LanguageService.translateBusinessAreaTagOptions(translations);

  return (
    <div>
      {cell}
      <br />
      <Dropdown
        className="business-areas-dropdown"
        placeholder="Add Business Area"
        defaultValue={row.business_area_list}
        options={options}
        onChange={handleDropdownChange}
        disabled={!canUpdate}
        fluid
        multiple
        search
        selection
        closeOnBlur
        closeOnChange
      ></Dropdown>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/plan_tables/formatters/workphase_cell_formatter.js